import type { ObjectiveCondition } from '@/types/objective'

import {
  OBJECTIVES_FEATURE_COPY,
  resolveResourceType
} from '@/shared/resourceModuleParity'

const COMPLETE_VERB_IMPERATIVE: Record<string, string> = {
  conclua: 'Conclua',
  leia: 'Leia',
  'participe de': 'Participe de',
  visite: 'Visite',
  assista: 'Assista'
}

export function getActionLabel(condition: ObjectiveCondition): string {
  const resolved = resolveResourceType(condition.resource_type)

  const verbImperative =
    condition.action_type === 'like'
      ? 'Curta'
      : (COMPLETE_VERB_IMPERATIVE[resolved.completeVerb] ?? 'Conclua')

  if (condition.mode === 'specific') {
    const count = condition.resource_ids.length || 1
    const noun = count === 1 ? resolved.label.singular : resolved.label.plural
    return `${verbImperative} ${noun} específico${count === 1 ? '' : 's'}`
  }

  const n = condition.quantity
  return `${verbImperative} ${n} ${n === 1 ? resolved.label.singular : resolved.label.plural}`
}

export function getConditionInstruction(condition: ObjectiveCondition): string {
  const resolved = resolveResourceType(condition.resource_type)

  if (condition.mode === 'specific') {
    const count = condition.resource_ids.length || 1
    const verb = condition.action_type === 'like' ? 'Curta' : 'Conclua'
    const noun =
      count === 1
        ? `o ${resolved.label.singular.toLowerCase()} específico`
        : `os ${resolved.label.plural.toLowerCase()} específicos`
    return `${verb} ${noun} ${OBJECTIVES_FEATURE_COPY.specificResourceTail({ count })}`
  }

  const n = condition.quantity
  const noun = (n === 1 ? resolved.label.singular : resolved.label.plural).toLowerCase()
  const verb = condition.action_type === 'like' ? 'curta' : resolved.completeVerb

  let text = `Acesse ${resolved.sectionPrep} e ${verb} ${n} ${noun}`
  if (condition.threshold != null) {
    text += `, obtendo pelo menos ${condition.threshold}% de acerto`
  }
  return `${text}.`
}
